module.exports = "/images/arrow-down.svg?158c898604cf1c5a77bfeaa30c524863";